import FBIcon from "../../components/shared/icons/fb";
import InstaIcon from "../../components/shared/icons/instagram";
import TikTokIcon from "../../components/shared/icons/tiktok";
import LinkedinIcon from "../../components/shared/icons/linkedin";
import XIcon from "../../components/shared/icons/x";
import WhatsupIcon from "../../components/shared/icons/whatsup";
import ViberIcon from "../../components/shared/icons/viber";
import TelegramIcon from "../../components/shared/icons/telegram";
import BehanceIcon from "../../components/shared/icons/behance";
import DribbbleIcon from "../../components/shared/icons/dribbble";
import YoutubeIcon from "../../components/shared/icons/youtube";
import MapIcon from "../../components/shared/icons/map";
import PhoneIcon from "../../components/shared/icons/phone";
import EmailIcon from "../../components/shared/icons/email";
import WifiIcon from "../../components/shared/icons/wifi";
import MenuIcon from "../../components/shared/icons/menu";
import ReviewIcon from "../../components/shared/icons/review";

const sanitize = (str: string) =>
  str
    ?.toString()
    .toLowerCase()
    .replace(/[^a-z0-9äöüÄÖÜß]/gi, "")
    .trim();

type MyObject = {
  [key: string]: any;
};

export const availableRoutes = [
  "shop",
  "plans",
  "partners",
  "contact",
  "privacy",
  "terms",
  "blog",
  "accounts",
  "admin",
  "settings",
  "auth",
  "login",
  "verification",
];

export const helpers = {
  customImgLoader: ({ src }: any) => {
    return `${src}`;
  },

  filterObject: (obj: MyObject, keysToKeep: string[]) => {
    return Object.entries(obj).reduce((acc: MyObject, [key, value]) => {
      if (!keysToKeep.includes(key)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  },

  isInteger: (data: number) => {
    if (Number.isInteger(data)) {
      return data;
    } else {
      return data.toFixed(2);
    }
  },

  hexToRgb: (hex: string) => {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return `${r}, ${g}, ${b}`;
  },

  getIconComponent: (title: string, color: string) => {
    let IconComponent;
    switch (title) {
      case "Facebook":
        IconComponent = FBIcon;
        break;
      case "Instagram":
        IconComponent = InstaIcon;
        break;
      case "TikTok":
        IconComponent = TikTokIcon;
        break;
      case "LinkedIn":
        IconComponent = LinkedinIcon;
        break;
      case "Twitter":
        IconComponent = XIcon;
        break;
      case "WhatsApp":
        IconComponent = WhatsupIcon;
        break;
      case "Viber":
        IconComponent = ViberIcon;
        break;
      case "Telegram":
        IconComponent = TelegramIcon;
        break;
      case "Behance":
        IconComponent = BehanceIcon;
        break;
      case "Dribbble":
        IconComponent = DribbbleIcon;
        break;
      case "YouTube":
        IconComponent = YoutubeIcon;
        break;
      case "Web Site":
        IconComponent = MapIcon;
        break;
      case "Phone":
        IconComponent = PhoneIcon;
        break;
      case "Email":
        IconComponent = EmailIcon;
        break;
      case "Wi-Fi":
        IconComponent = WifiIcon;
        break;
      case "Menu":
        IconComponent = MenuIcon;
        break;
      case "Review":
        IconComponent = ReviewIcon;
        break;
      default:
        IconComponent = null;
    }
    return IconComponent ? <IconComponent color={color} /> : null;
  },

  formatNumber: (
    number: number,
    options: {
      maximumFractionDigits?: number;
      minimumFractionDigits?: number;
    } = {}
  ) => {
    const { maximumFractionDigits = 2, minimumFractionDigits = 0 } = options;

    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits,
      minimumFractionDigits,
    }).format(number);
  },

  social: () => {
    return [
      {
        id: 1,
        title: "Facebook",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.facebook.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/9735717120283524_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 25,
      },
      {
        id: 2,
        title: "Instagram",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.instagram.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/2176242173844966_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 25,
      },
      {
        id: 3,
        title: "TikTok",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.tiktok.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/5145709698955522_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 25,
      },
      {
        id: 4,
        title: "LinkedIn",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.linkedin.com/in/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/7192529287736649_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 25,
      },
      {
        id: 5,
        title: "Twitter",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.twitter.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/7488328141453828_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 5,
        opacity: 80,
      },
      {
        id: 6,
        title: "WhatsApp",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://wa.me/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/8235049788959328_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
        isPhone: true,
      },
      {
        id: 7,
        title: "Viber",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://viber://add?number=",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/9370199554036128_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
        isPhone: true,
      },
      {
        id: 8,
        title: "Telegram",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.t.me/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/6681294151219563_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
        isPhone: true,
      },
      {
        id: 9,
        title: "Behance",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.behance.net/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/7549364860793911_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 10,
        title: "Dribbble",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.dribbble.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/8852944385062575_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 11,
        title: "YouTube",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.youtube.com/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/6968322753147275_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 12,
        title: "Web Site",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/8045980753603745_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 13,
        title: "Phone",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/8413940918103311_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
        isPhone: true,
      },
      {
        id: 14,
        title: "Email",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/0948054618319874_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 15,
        title: "Wi-Fi",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "wifi://:password@ssid",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/4963240445526681_2022-08-07.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
        isNetwork: true,
      },
      {
        id: 16,
        title: "Menu",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/5347202583552789_2023-04-10.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 17,
        title: "Review",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/4663837623023950_2023-04-10.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
      {
        id: 18,
        title: "Map",
        textAndIconColor: "#FFFFFF",
        buttonColor: "#11171C ",
        baseUrl: "https://www.google.com/maps/place/",
        imageUrl:
          "https://storage.googleapis.com/touch-talk-image.appspot.com/2562620492756535_2022-08-27.svg",
        shadowColor: "#000000CC",
        x: 0,
        y: 25,
        blur: 25,
        spread: 25,
        opacity: 80,
      },
    ];
  },
  checking: (item: string, selected: string[], setSelected: Function) => {
    if (selected.includes(item)) {
      setSelected(selected.filter((i) => i !== item));
    } else {
      setSelected((prev: any) => [...prev, item]);
    }
  },

  changeState: (
    e: React.ChangeEvent<HTMLInputElement>,
    defaultState: any,
    setState: Function,
    edit?: boolean
  ) => {
    if (
      edit &&
      defaultState[e.target.name].split(" ").join("") ===
        e.target.value.split(" ").join("")
    ) {
      setState((prevState: any) => ({
        ...prevState,
        [e.target.name]: defaultState[e.target.name],
      }));
    } else {
      setState((prevState: any) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  },

  email: (value: any) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value);
  },

  redirectTo: (path: string) => {
    window.location.href = path;
  },

  checkProperties: (obj: any) => {
    let isEmpty = obj
      ? Object.values(obj).some(
          (o: any) =>
            o.toString().replace(/[^a-z0-9]/gi, "") === "" ||
            o == null ||
            o.toString() === "[]"
        )
      : true;
    return isEmpty;
  },

  filter: (item: any, field: string, searchValue: any) => {
    return item.filter(
      (space: any) =>
        sanitize(space[field]).includes(sanitize(searchValue)) ||
        sanitize(searchValue).includes(sanitize(space[field]))
    );
  },
};
